<template>
<div class="interpretationsSidebar">
  <!--
  <div v-for="response, index in responsesList" :key="response.responseId + '_' + response.rousselotPhoneticForm">
    <h5 v-if="hasPhoneticTranscription()">Transcription phonétique : {{response.rousselotPhoneticForm}} {{response.complementaryInformation}}</h5>
    <div v-if="!hasPhoneticTranscription() && mode != 'phoneticTranscription'">Pas de transcription phonétique</div>
    <div v-if="isAuthenticated && !hasPhoneticTranscription() && mode === 'phoneticTranscription'">
      <phonetic-transcriptions-creation v-bind:replace="true" v-on:closePhoneticTranscriptionCreation="closeSideBar()"></phonetic-transcriptions-creation>
    </div>
  </div>
  -->

  <div v-if="hasPhoneticTranscription() && responsesList.length > 1">
     <p>transcriptions phonétiques :
            <span v-for="(response, index) in responsesList" :key="response.responseId + '_' + response.rousselotPhoneticForm">
                {{ response.rousselotPhoneticForm }}
                {{ response.complementaryInformation !== "" ? '(' + responsesList[index].complementaryInformation + ')' : ""}}
                {{ index < responsesList.length -1 ? ', ' : ''}}
            </span>
     </p>
  </div>
  <div v-if="hasPhoneticTranscription() && responsesList.length == 1">
      <p>transcription phonétique :
        {{ responsesList[0].rousselotPhoneticForm}}
        {{ responsesList[0].complementaryInformation !== "" ? '(' + responsesList[0].complementaryInformation + ')' : ""}}
      </p>
  </div>
  <div v-if="!hasPhoneticTranscription()" >
    <p>Pas de transcription phonétique</p>
  </div>
   <div v-if="!hasPhoneticTranscription() && isAuthenticated && mode === 'phoneticTranscription' ">
        <phonetic-transcriptions-creation v-bind:replace="true" v-on:closePhoneticTranscriptionCreation="closeSideBar()"></phonetic-transcriptions-creation>
  </div>

  <phonetic-transcriptions-consultation  v-if="hasPhoneticTranscription() && mode === 'phoneticTranscription'" v-bind:responsesList="responsesList"></phonetic-transcriptions-consultation>

  <interpretations-creation v-if="isInterpretationsCreationActivated" v-on:closeInterpretationCreation="showOrHideInterpretationCreation()" v-bind:rousselotPhoneticFormList="rousselotPhoneticFormList">
  </interpretations-creation>
  <interpretations-consultation v-if="!isInterpretationsCreationActivated && !isInterpretationsEditionActivated && mode != 'phoneticTranscription'" v-on:openEdition="showOrHideInterpretationEdition"></interpretations-consultation>
  <interpretations-edition v-if="isInterpretationsEditionActivated" v-on:closeInterpretationEdition="showOrHideInterpretationEdition()" v-bind:interpretationToEdit="interpretationToEdit" v-bind:rousselotPhoneticForm="rousselotPhoneticForm">
  </interpretations-edition>

  <br>
    <b-button v-if="!isInterpretationsCreationActivated && !isInterpretationsEditionActivated && isAuthenticated
    && hasPhoneticTranscription() && (mode != 'phoneticTranscription')" variant="success" @click="showOrHideInterpretationCreation()">Créer une annotation</b-button>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@components/bus/bus.js';

import InterpretationsConsultation from '@components/commons/sideBarViewer/interpretationsSideBar/InterpretationsConsultation'
import InterpretationsEdition from '@components/commons/sideBarViewer/interpretationsSideBar/InterpretationsEdition'
import InterpretationsCreation from '@components/commons/sideBarViewer/interpretationsSideBar/InterpretationsCreation'
import PhoneticTranscriptionsCreation from '@components/commons/sideBarViewer/phoneticTranscriptionsSideBar/PhoneticTranscriptionsCreation'
import PhoneticTranscriptionsConsultation from '@components/commons/sideBarViewer/phoneticTranscriptionsSideBar/PhoneticTranscriptionsConsultation'

export default {
  name: 'InventoryEntrySideBar',
  components: {
    InterpretationsConsultation,
    InterpretationsEdition,
    InterpretationsCreation,
    PhoneticTranscriptionsCreation,
    PhoneticTranscriptionsConsultation
  },
  computed: {
    ...mapGetters({
      currentInventoryEntry: 'getCurrentInventoryEntry',
      isAuthenticated: 'getIsAuthenticated',
      responsesList: 'getResponsesList',
      mode: 'getMode'
    })
  },

  data() {
    return {
      isInterpretationsCreationActivated: false,
      isInterpretationsEditionActivated: false,
      interpretationToEdit: null,
      rousselotPhoneticFormList: []
    }
  },

  watch: {
    // Si l'entrée d'inventaire courante change, fermeture de l'édition d'interprétation
    watch() {
      this.currentInventoryEntry
      this.showOrHideInterpretationEdition()
          EventBus.$on('closeSideBar', this.closeSideBar())
     }
  },

  created() {
    this.$store.dispatch('getResponses', this.currentInventoryEntry.inventoryEntry).then(() => { this.setRousselotPhoneticFormList() })
    this.$store.dispatch('getAllInterpretations', this.currentInventoryEntry.inventoryEntry)
  },

  methods: {

    // ---------------------------------------------------------------------------------------------
    // GESTION DU COMPOSANT DE CREATION DE TRANSCRIPTIONS PHONETIQUES
    // ---------------------------------------------------------------------------------------------

    // Création d'un tableau contenant les forme phonétiques des réponses associées à une entrée d'inventaire
    setRousselotPhoneticFormList: function() {
      for (let i = 0; i < this.responsesList.length; i++) {
        if(this.responsesList[i].rousselotPhoneticForm != 'forme phonétique non encore renseignée') {
        this.rousselotPhoneticFormList.push(this.responsesList[i].rousselotPhoneticForm)
      }
      return this.rousselotPhoneticFormList
      }
    },
    // Booleen permettant d'afficher ou non le composant de création de transcription phonétique
    hasPhoneticTranscription: function() {
      if(this.responsesList[0].rousselotPhoneticForm != 'forme phonétique non encore renseignée') {
          return true
      } else {
          return false
      }
    },

    // ---------------------------------------------------------------------------------------------
    // GESTION DES COMPOSANTS CREATION ET EDITION D'INTERPRETATIONS
    // ---------------------------------------------------------------------------------------------

    // Ouvre ou ferme le composant de création d'interprétation
    // Si le mode création est activé, alors le composant de consultation se ferme
    showOrHideInterpretationCreation: function() {
      this.isInterpretationsCreationActivated = !this.isInterpretationsCreationActivated
    },
    // Ouvre ou ferme le composant d'édition d'interprétation
    // Si le mode édition est activé, alors le composant de consultation se ferme
    showOrHideInterpretationEdition: function(data) {
      if (!this.isInterpretationsEditionActivated) {
        this.interpretationToEdit = data.interpretation
        this.rousselotPhoneticForm = data.rousselotPhoneticForm
        this.isInterpretationsEditionActivated = true
      } else {
        this.interpretationToEdit = null
        this.isInterpretationsEditionActivated = false
      }
    }
  }
}
</script>
<style>
.interpretationsSidebar {
  height: 55em;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/sideBarViewer/InventoryEntrySideBar.vue